var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},_vm._l((5),function(i){return _c('vue-content-loading',{key:i,staticClass:"mb-5",attrs:{"width":1920,"height":400}},[_c('rect',{attrs:{"x":"0","y":"0","rx":"3","ry":"3","width":"48%","height":"400"}}),_c('rect',{attrs:{"x":"50%","y":"0","rx":"3","ry":"3","width":"48%","height":"400"}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }